import { render, staticRenderFns } from "./CNCAxesPosition.vue?vue&type=template&id=9d634378&scoped=true"
import script from "./CNCAxesPosition.vue?vue&type=script&lang=ts"
export * from "./CNCAxesPosition.vue?vue&type=script&lang=ts"
import style0 from "./CNCAxesPosition.vue?vue&type=style&index=0&id=9d634378&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d634378",
  null
  
)

export default component.exports